export class Proveedor {
  t2_id: string | null;
  t2_dni: string;
  t2_ruc: string;
  t2_razon: string;
  t2_estado: number;

  constructor() {
    this.t2_id = null;
    this.t2_dni = '';
    this.t2_ruc = '';
    this.t2_razon = '';
    this.t2_estado = 1;
  }
}
